module.exports = __webpack_public_path__ + "static/img/vg.cd9d438b.svg";